import React from "react";
import { styled } from "@mui/system";
import MUIListItemText, { ListItemTextProps } from "@mui/material/ListItemText";

export const ListItemText = styled(
  (props: ListItemTextProps) => <MUIListItemText {...props} />,
  {
    name: "ListItemText",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "& .MuiTypography-root.MuiListItemText-primary": {
    ...theme.typography["body"],
  },
  "& .MuiTypography-root.MuiListItemText-secondary": {
    ...theme.typography["body"],
    color: theme.palette.primary.textSubduedColor,
  },
}));
